var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skeleton-columns" }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-center" },
      _vm._l(7, function(index) {
        return _c(
          "div",
          { key: index, staticClass: "column" },
          _vm._l(4, function(index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "column-preview",
                class: { "bg-gray": index === 2 || index === 4 }
              },
              [_c("div", { staticClass: "content-preview" })]
            )
          })
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7323a098", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7323a098","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/loading/jSkeletonTable.vue
// module id = null
// module chunks = 